import { ThemeConfig } from 'antd';
import { colors, palette } from './palette';
import { fontFamilies } from './typography';

export const antdTheme: ThemeConfig = {
    token: {
        colorPrimary: colors.brandCta,
        colorLink: colors.link,
        colorText: colors.textDefault,
        colorBgLayout: colors.bgPage,
        borderRadius: 6,
        fontFamily: fontFamilies.sans,
        fontSize: 16,
    },
    components: {
        Carousel: {
            arrowSize: 24,
        },
        Button: {
            controlHeightSM: 29,
            controlHeight: 40,
            controlHeightLG: 48,
            fontWeight: 700,
        },
        Table: {
            headerBg: palette.burgundy[800],
            headerColor: palette.white,
            headerSplitColor: palette.burgundy[800],
        },
        Tabs: {
            inkBarColor: colors.brandCta,
            itemSelectedColor: colors.brandCta,
        },
    },
};
